import React from 'react';
import ComingSoon from 'common/designer-modules/modules/coming-soon';
import PageHeader from 'common/designer-modules/modules/page-header';
import Footer from 'common/designer-modules/modules/footer';
import { useSelector } from 'react-redux';
import { siteInfoSelector } from 'admin/state/modules/common/selectors';
import PropTypes from 'prop-types';

const PreviewComingSoon = ({
   isMobile,
   globalSettings,
}) => {
   const siteInfo = useSelector(siteInfoSelector);

   return (
      <>
         <PageHeader
            globalSettings={ globalSettings }
            siteName={ siteInfo.site_long_name }
            isPreview
         />
         <div className='w-full relative h-[550px] overflow-y-auto'>
            <ComingSoon
               globalSettings={ globalSettings }
               isMobile={ isMobile }
            />
            <div className='h-[920px] bg-error-12'>

               <Footer />
            </div>
         </div>
      </>
   )
}

PreviewComingSoon.propTypes = {
   isMobile: PropTypes.bool,
   globalSettings: PropTypes.object,
}

export default PreviewComingSoon;
